import ReactPaginate from 'react-paginate';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './Pagination.module.css';

/**
 * Управляемая пагинация: сама ничего не запрашивает.
 * Страница хранится в URL — используйте вместе с useUrlPagination:
 *
 *   const { page, offset, pageSize, setPage } = useUrlPagination(10);
 *   useEffect(() => { load(pageSize, offset) }, [page, ...фильтры]);
 *   <Pagination page={page} total={data.totalCount} pageSize={pageSize} onPageChange={setPage} />
 *
 * @param {number} page — текущая страница, с 1
 * @param {number} total — всего элементов
 * @param {number} pageSize
 * @param {(page: number) => void} onPageChange — новая страница, с 1
 */
export const Pagination = ({ page = 1, total = 0, pageSize = 10, onPageChange, className = '' }) => {
  const pageCount = Math.ceil((total || 0) / pageSize);
  if (pageCount <= 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <span className={styles.summary}>
        {from}–{to} из {total}
      </span>
      <ReactPaginate
        pageCount={pageCount}
        forcePage={Math.min(page, pageCount) - 1}
        onPageChange={(e) => {
          onPageChange(e.selected + 1);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        previousLabel={<ChevronLeft size={16} />}
        nextLabel={<ChevronRight size={16} />}
        breakLabel="…"
        containerClassName={styles.list}
        pageLinkClassName={styles.link}
        previousLinkClassName={styles.link}
        nextLinkClassName={styles.link}
        breakLinkClassName={`${styles.link} ${styles.break}`}
        activeLinkClassName={styles.active}
        disabledLinkClassName={styles.disabled}
      />
    </div>
  );
};
